import api from './api';

const ENDPOINT = 'redemptions';

const RedemptionService = {
  get: (params = null) => api.get(ENDPOINT, { params }),
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
  save: (data) => api.post(`${ENDPOINT}`, data),
  update: (id, data) => api.put(`${ENDPOINT}/${id}`, data),
  delete: (id) => api.delete(`${ENDPOINT}/${id}`),
  search: (term) => api.get(`${ENDPOINT}/search`, { params: { term } }),
  export: (filters) => api.post(`${ENDPOINT}/export`, { filters }),
  getTypes: () => api.get(`${ENDPOINT}/types`),
};

export default RedemptionService;
